// Display-only person-name normalisation ("JESPER SENKE" -> "Jesper Senke").
// Mirror of MOVARO.Authorization.Users.NameFormatter on the backend - keep in sync.
//
// Conservative: a word is only re-cased when it is entirely UPPER or entirely lower
// case. Mixed-case words ("McDonald", "DeLaCruz") are assumed to be deliberate.

// Linking particles that stay lower case when followed by another word ("af Klint").
const PARTICLES = new Set(["af", "av", "von", "van", "der", "den", "de", "del", "della", "di", "da", "du", "la", "le", "ten", "ter", "zu"]);

// "Senke" (one leading capital) is normal; mixed means a capital after the first letter.
const hasMixedCase = (value) => /[\p{Ll}]/u.test(value) && /\p{Lu}/u.test(value.slice(1));

const formatPart = (part) => {
  if (!part || hasMixedCase(part)) return part;
  return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
};

const formatWord = (word, isLastWord) => {
  if (!isLastWord && PARTICLES.has(word.toLowerCase()) && !hasMixedCase(word)) {
    return word.toLowerCase();
  }
  // Split on hyphen / apostrophe but keep the separators: "ANNA-LENA" -> "Anna-Lena".
  return word
    .split(/([-'’])/)
    .map((piece) => (/^[-'’]$/.test(piece) ? piece : formatPart(piece)))
    .join("");
};

export function formatPersonName(name) {
  if (typeof name !== "string" || !name.trim()) return name || "";
  const words = name.trim().split(/\s+/);
  return words.map((word, index) => formatWord(word, index === words.length - 1)).join(" ");
}

export function formatFullName(firstName, surname) {
  return [formatPersonName(firstName), formatPersonName(surname)].filter(Boolean).join(" ");
}
